import React, {useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import EventTable from '../../../features/page/leaderboard/event/EventTable'
import {AddLeaderContainer} from '../../../features/page/leaderboard/paytosee/AddLeaderContainer'
import PaytoSeeLeadersTable from '../../../features/page/leaderboard/paytosee/PaytoSeeLeadersTable'
import {createPaytoSeeLeader} from '../../../apis/leader/payToSee'

interface IProps {
    className?: string
}

const PaytoSeePage: React.FC<IProps> = ({className}) => {
    const [leaderID, setLeaderID] = useState('')
    const onClickCreateLeader = async (leaderId: string) => {
        await createPaytoSeeLeader({user_id: leaderId, tag: 'pts'})
            .then(data => {
                data.status !== 200
                    ? alert('Failed to create leader. Please try again.')
                    : alert('Leader created successfully')
                setLeaderID('')
            })
            .catch(err => {
                console.error('Error creating leader:', err)
                alert('Failed to create leader. Please try again.')
            })
    }

    return (
        <PageLayout title={'Pay to See leaders'}>
            <AddLeaderContainer input={leaderID} onClick={e => onClickCreateLeader(e)} />

            <div className={'mt-[30px]'}>
                <PaytoSeeLeadersTable />
            </div>
        </PageLayout>
    )
}

export default PaytoSeePage
